import { Spinner, Stack, useToast, VStack } from "@chakra-ui/react";
import { matchPath, useLocation, useParams } from "react-router-dom";
import { useKydEvent } from "../../hooks/useKydEvent";
import EventDetailSections from "../../sections/EventDetailSections";
import { createOnUpdateEvent, EditModalType } from "../../../../utils";
import { useCallback, useMemo, useState } from "react";
import { useLoading } from "../../../hooks/form";
import { pollForEventUpdateStatus as pollForStatus } from "../../utils/poolForEventUpdateStatus";
import { useDialog } from "../../../../Common/Dialog";

const WaitlistNavSection = () => {
  const { event_id } = useParams();
  const location = useLocation();
  const { kydEvent, loading: isEventLoading, refetch } = useKydEvent(event_id);
  const [modalType, setModalType] = useState(EditModalType.INACTIVE);
  const [loading, updateLoading] = useLoading({
    event: false,
  });
  const dialog = useDialog();
  const toast = useToast();

  const currentNavTabSections = useMemo(() => {
    if (!kydEvent) return [];

    const currentTab = kydEvent.nav.find((nav) =>
      matchPath(nav.url, location.pathname)
    );
    if (currentTab) {
      return currentTab.sections;
    }

    return [];
  }, [kydEvent]);

  const pollForEventUpdateStatus = useCallback(() => {
    return pollForStatus({
      onError: (text) => dialog({ text }),
      refetch: () => refetch({ silent: true }),
      event_id,
    });
  }, [event_id, dialog, refetch]);

  const onUpdateEvent = useCallback(
    createOnUpdateEvent({
      dialog,
      event_id,
      pollForEventUpdateStatus,
      refetch,
      setLoading: (isLoading) => updateLoading("event", isLoading),
      setModalType,
      toast,
    }),
    [
      event_id,
      refetch,
      updateLoading,
      pollForEventUpdateStatus,
      dialog,
      toast,
      setModalType,
    ]
  );

  return (
    <Stack maxW="5xl" w="full">
      {!kydEvent?.nav ? (
        <VStack w="100%">
          <Spinner />
        </VStack>
      ) : null}
      <EventDetailSections
        isLoading={isEventLoading || loading.event}
        onUpdateEvent={onUpdateEvent}
        setModalType={setModalType}
        refetchEvent={refetch}
        modalType={modalType}
        sections={currentNavTabSections}
        pollForEventUpdateStatus={pollForEventUpdateStatus}
      />
    </Stack>
  );
};

export default WaitlistNavSection;
